import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { api, baseURL } from 'server-api';
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import Button from "components/button/Button";

export default function ViewPost(props){
  const {t} = useTranslation();
  const navigate = useNavigate();
  const body = props.body? props.body:'';
  const time = props.createdAt? props.createdAt.split('T')[0]:'';
  const editUrl = props.editUrl;

  const handleDelete = ()=>{
    const send = async()=>{
      if(window.confirm("정말 삭제하시겠습니까?")){
        try{
          await api.delete(`/posts/${props.id}`);
          navigate(-1);
        }catch(err){
          alert("오류가 발생했습니다.");
        }
      }
    }
    send();
  }

  const handleModify = ()=>{
    navigate(`${editUrl}/${props.id}`)
  };

  const handleBack = ()=>{
    navigate(-1);
  };
  return (
    <div className="flex flex-col">
      <div className="my-5 border border-t-hover border-b-gray-500">
        <div className="px-4 py-4">
          <p className="text-2xl">{props.title}</p>
        </div>
        <div className="flex justify-end px-4 py-2 bg-gray-100 border border-t-gray-400 border-b-gray-400">
          <p className="text-base text-gray-500">{time}</p>
        </div>
        {/*<div className="m-2">
          <img src={`${baseURL}${props.thumbnail}`} style={{width:'300px'}} alt={props.title}/>
        </div>*/}
        <div className="">
          <ReactQuill
            value={body}
            readOnly={true}
            theme="snow"
            modules={{ toolbar: false }}
            style={{ height: 'auto', backgroundColor: 'white' }}
          />
        </div>
      </div>
      <div className='flex justify-end mb-4'>
        <Button handler={handleBack} className="mr-2">{t('common.back')}</Button>
      {localStorage.getItem('token')?
      <>
        <Button handler={handleModify} className="mr-2">수정</Button>
        <Button handler={handleDelete}>삭제</Button>
      </>
      :null}
      </div>
    </div>
  );
}